// import React, { useEffect, useState } from 'react';
// import axiosInstance from '../request';
// import { URL } from '../api';
// import { useNavigate } from "react-router-dom";

// const RejectLoanList = () => {
//   const navigate = useNavigate();
//   const [rejectedLoans, setRejectedLoans] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // ✅ Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const recordsPerPage = 10;

//   useEffect(() => {
//     const fetchRejectedLoans = async () => {
//       try {
//         const response = await axiosInstance.get(URL.LOAN_REJECT);
//         const formattedData = response.data.map((loan) => ({
//           id: loan.loan_id,
//           customerId: loan.customer_id,
//           customerName: loan.borrower_name || 'N/A',
//           loanType: loan.loan_type_name || 'N/A',
//           amount: loan.loan_amount || 0,
//           rejectionReason: loan.rejection_reason || 'N/A',
//           appliedDate: loan.create_date || 'N/A',
//           status: loan.status_name || 'N/A',
//         }));
//         setRejectedLoans(formattedData);
//       } catch (error) {
//         console.error('Error fetching rejected loans:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchRejectedLoans();
//   }, []);

  
//   // ✅ Pagination calculations
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = rejectedLoans.slice(indexOfFirstRecord, indexOfLastRecord);
//   const totalPages = Math.ceil(rejectedLoans.length / recordsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // ✅ Generate compact page numbers
//   const getPageNumbers = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (currentPage <= 3) {
//         pages.push(1, 2, 3, '...', totalPages);
//       } else if (currentPage >= totalPages - 2) {
//         pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
//       } else {
//         pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
//       }
//     }
//     return pages;
//   };

//   if (loading) {
//     return <div className="container">Loading...</div>;
//   }

//   return (
//     <div className="container">
//       <h3 className="mb-4">Rejected Loan Applications</h3>
//       <div className="table-responsive">
//         <table className="table table-bordered table-hover align-middle">
//           <thead className="table-dark">
//             <tr>
//               <th>S.No.</th>
//               <th>Customer Name</th>
//               <th>Loan Type</th>
//               <th>Amount</th>
//               <th>Rejection Reason</th>
//               <th>Applied Date</th>
//               <th>Status</th>
//               <th>Action</th>
//               <th>Reject Summary</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentRecords.length > 0 ? (
//               currentRecords.map((loan, index) => (
//                 <tr key={loan.id}>
//                   <td>{indexOfFirstRecord + index + 1}</td>
//                   <td>{loan.customerName}</td>
//                   <td>{loan.loanType}</td>
//                   <td>₹{loan.amount.toLocaleString()}</td>
//                   <td>{loan.rejectionReason}</td>
//                   <td>{loan.appliedDate}</td>
//                   <td>
//                     <span className="badge bg-danger">{loan.status}</span>
//                   </td>
//                   <td>
//                     <button
//                       className="btn btn-sm btn-primary"
//                       onClick={() => navigate(`/CustomerView?customer_id=${loan.customerId}`)}
//                     >
//                       View
//                     </button>
//                   </td>
//                   <td>
//                     <button
//                       className="btn btn-sm btn-warning"
//                       onClick={() => navigate(`/RejectSummary?customer_id=${loan.customerId}&loan_id=${loan.id}`)}
//                     >
//                       Summary
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="text-center text-muted">
//                   No rejected loans found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ✅ Compact Pagination */}
//       {totalPages > 1 && (
//         <nav className="mt-3">
//           <ul className="pagination justify-content-center">
//             <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//               <button className="page-link" onClick={() => paginate(currentPage - 1)}>Prev</button>
//             </li>

//             {getPageNumbers().map((number, idx) => (
//               <li
//                 key={idx}
//                 className={`page-item ${currentPage === number ? "active" : ""} ${number === "..." ? "disabled" : ""}`}
//               >
//                 <button
//                   className="page-link"
//                   onClick={() => typeof number === "number" && paginate(number)}
//                   disabled={number === "..."}
//                 >
//                   {number}
//                 </button>
//               </li>
//             ))}

//             <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//               <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
//             </li>
//           </ul>
//         </nav>
//       )}
//     </div>
//   );
// };

// export default RejectLoanList;


import React, { useEffect, useState } from 'react';
import axiosInstance from '../request';
import { URL } from '../api';
import { useNavigate } from "react-router-dom";

const RejectLoanList = () => {

  const navigate = useNavigate();

  const [rejectedLoans, setRejectedLoans] = useState([]);
  const [loading, setLoading] = useState(false);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [hasNextPage, setHasNextPage] = useState(false);

  const companyCode = localStorage.getItem("companyCode");
  const branchCode = localStorage.getItem("branch_code");


  const fetchRejectedLoans = async (page = 1) => {

    setLoading(true);

    try {

      const params = {
        companyCode,
        branchCode,
        page: page - 1,
        size: rowsPerPage
      };

      const response = await axiosInstance.get(URL.LOAN_REJECT, { params });

      const data = Array.isArray(response.data) ? response.data : [];

      const formattedData = data.map((loan) => ({
        id: loan.loan_id,
        customerId: loan.customer_id,
        customerName: loan.borrower_name || 'N/A',
        loanType: loan.loan_type_name || 'N/A',
        amount: loan.loan_amount || 0,
        rejectionReason: loan.rejection_reason || 'N/A',
        appliedDate: loan.create_date || 'N/A',
        status: loan.status_name || 'N/A',
      }));

      setRejectedLoans(formattedData);

      setCurrentPage(page);

      setHasNextPage(data.length === rowsPerPage);

    } catch (error) {

      console.error('Error fetching rejected loans:', error);

      setRejectedLoans([]);

      setHasNextPage(false);

    } finally {

      setLoading(false);

    }

  };


  useEffect(() => {
    fetchRejectedLoans(1);
  }, []);



  if (loading) {
    return <div className="container">Loading...</div>;
  }

  return (

    <div className="container">

      <h3 className="mb-4">Rejected Loan Applications</h3>

      <div className="table-responsive">

        <table className="table table-bordered table-hover align-middle">

          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>Customer Name</th>
              <th>Loan Type</th>
              <th>Amount</th>
              <th>Rejection Reason</th>
              <th>Applied Date</th>
              <th>Status</th>
              <th>Action</th>
              <th>Reject Summary</th>
            </tr>
          </thead>

          <tbody>

            {rejectedLoans.length > 0 ? (

              rejectedLoans.map((loan, index) => (

                <tr key={loan.id}>

                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

                  <td>{loan.customerName}</td>

                  <td>{loan.loanType}</td>

                  <td>₹{loan.amount.toLocaleString()}</td>

                  <td>{loan.rejectionReason}</td>

                  <td>{loan.appliedDate}</td>

                  <td>
                    <span className="badge bg-danger">{loan.status}</span>
                  </td>

                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => navigate(`/CustomerView?customer_id=${loan.customerId}`)}
                    >
                      View
                    </button>
                  </td>

                  <td>
                    <button
                      className="btn btn-sm btn-warning"
                      onClick={() => navigate(`/RejectSummary?customer_id=${loan.customerId}&loan_id=${loan.id}`)}
                    >
                      Summary
                    </button>
                  </td>

                </tr>

              ))

            ) : (

              <tr>
                <td colSpan="9" className="text-center text-muted">
                  No rejected loans found.
                </td>
              </tr>

            )}

          </tbody>

        </table>

      </div>


      {/* Pagination */}

      <div className="d-flex justify-content-center mt-3">

        <div className="d-flex align-items-center" style={{ gap: "10px" }}>

          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => fetchRejectedLoans(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>

          <span className="fw-semibold">Page {currentPage}</span>

          {hasNextPage && <span className="text-muted">...</span>}

          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => fetchRejectedLoans(currentPage + 1)}
            disabled={!hasNextPage}
          >
            Next
          </button>

        </div>

      </div>

    </div>

  );

};

export default RejectLoanList;